// extracted by mini-css-extract-plugin
module.exports = {"gaugeWrapper":"AverageDiversity_gaugeWrapper__2xZ2M","low":"AverageDiversity_low__mzHIi","fair":"AverageDiversity_fair__1ipf1","high":"AverageDiversity_high__3LxRP"};